export const merchantYoutubeVideoURl = "https://youtu.be/XYtnQbdqOBs"

export const infoCenterUrl = "https://www.foodlabelsolutions.com/info-centre"

export const guideQrCodeBaseUrl = "https://www.meraqrcode.com/d/guides"
